import { Button } from '@optools/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@optools/components/ui/tooltip';
import { Upload } from 'lucide-react';

export interface AudienceDefinitionUploadProps {
  onChange: (details: string) => void;
  onError: (message: string) => void;
}
export function AudienceDefinitionUpload({ onChange, onError }: AudienceDefinitionUploadProps) {
  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) return;

    const [file] = event.target.files;

    const reader = new FileReader();

    reader.onload = (e) => {
      if (typeof e.target?.result !== 'string') {
        return onError(
          'An error occurred while reading the file, ensure that the file is not malformed.',
        );
      }

      const records = e.target.result
        .split(/[,\t\n\r\f\v]+/)
        .filter(Boolean)
        .join(',\n');
      onChange(records);
    };

    reader.onerror = () => {
      onError('An error occurred while reading the file, ensure that the file is not malformed.');
    };

    reader.readAsText(file);
  };

  return (
    <Tooltip delayDuration={250}>
      <TooltipTrigger asChild>
        <Button asChild size="icon" variant="ghost">
          <label className="cursor-pointer" htmlFor="upload-csv">
            <Upload />
            <span className="sr-only">Upload CSV</span>
            <input
              accept=".csv"
              className="hidden"
              id="upload-csv"
              type="file"
              onChange={handleFileChange}
            />
          </label>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="left">Upload CSV</TooltipContent>
    </Tooltip>
  );
}
